import { INTERNSHIP_STATUS, ROUTE_PATH, TEMPLATE_OPTIONS, regions, statusList } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel, SmMetaInputModel, SmDatepickerModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";



export class InternshipFilterMetaModel extends FormMetaModel {
    constructor() {
        super('', "", "", 3);
    }
    override initProperties(): any {
        const formInfo = super.initProperties();
        const searchText = new SmMetaInputModel(
            'searchText',
            'searchText',
            'input',
            false,
            'col-12 col-md-4',
            1,
            4,
            '',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
        const selectedBatch = new SmMetaSelectModel(
            'selectedBatch',
            'selectedBatch',
            'select',
            false,
            'col-sm-6 col-xs-12 col-md-4 col-lg-2',
            1,
            3,
            '',
            'select',
            'All Batch',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'batch_number',
            'batch_number',

        );
         
         const selectedRegion = new SmMetaSelectModel(
            'selectedRegion',
            'selectedRegion',
            'select',
            false,
            'col-sm-6 col-xs-12 col-md-4 col-lg-2',
            1,
            1,
            '',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            regions,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );

        const selectedBranch = new SmMetaSelectModel(
            'selectedBranch',
            'selectedBranch',
            'select',
            false,
            'col-2 col-md-2',
            1,
            1,
            '',
            'select',
            'All Branch',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'department_name',
            'id'
        );

        const selectedState = new SmMetaSelectModel(
            'selectedState',
            'selectedState',
            'select',
            false,
            'col-sm-6 col-xs-12 col-md-4 col-lg-2',
            1,
            1,
            '',
            'select',
            'All State',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            statusList,
            'stateName',
            'id',
        );

        const selectedStatus = new SmMetaSelectModel(
            'selectedStatus',
            'selectedStatus',
            'select',
            false,
            'col-sm-6 col-xs-12 col-md-4 col-lg-2',
            1,
            1,
            '',
            'select',
            'Current Status',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            INTERNSHIP_STATUS,
            'name',
            'id',
        );

        const fromDate = new SmDatepickerModel(
            'fromDate',
            'fromDate',
            'datepicker',
            false,
            'col-12 col-md-4 mb-2',
            1,
            2,
            'From Date',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
          );

        const toDate = new SmDatepickerModel(
            'toDate',
            'toDate',
            'datepicker',
            false,
            'col-12 col-md-4 mb-2',
            1,
            2,
            'To Date',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
          );

          const add = new SmBtnMetaModel('Add Internship', '', true, false, true, true, false);
       

        return {
            formInfo,
            selectedBatch,
            selectedBranch,
            selectedRegion,
            selectedState,
            selectedStatus,
            searchText,
            fromDate,
            toDate,
            add,
        }
    }
}